import actionTypes from "../actionTypes";

export const setMyProfileLoader = (data) => ({
  type: actionTypes.header.SET_MY_PROFILE_LOADER,
  payload: data,
});
